<hr>
<div class="container col-xxl-8 px-4">
  <footer class="row gy-4 py-5 align-items-start">
    <div class="col-12 col-lg-3 mb-3">
      <a href="/" class="d-inline-flex align-items-center mb-2 text-decoration-none">
        <img src="assets/images/landing/GeoAstra_logo_200x200.png" width="40" height="40" alt="GeoAstra Logo" loading="eager" style="display:inline-block">
      </a>
      <p class="text-body-secondary mb-0">&copy; 2025</p>
    </div>

    <div class="col-12 col-sm-6 col-lg-4">
      <h4>Company Info</h4>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a href="about-us" class="nav-link p-0 text-body-secondary">About Us</a></li>
        <li class="nav-item mb-2"><a href="contact-us" class="nav-link p-0 text-body-secondary">Contact Us</a></li>
        <li class="nav-item mb-2"><a href="https://community.geoastra.com/newsroom/" target="_blank" rel="noopener" class="nav-link p-0 text-body-secondary">News Room</a></li>
        <li class="nav-item mb-2"><a href="https://community.geoastra.com/" target="_blank" rel="noopener" class="nav-link p-0 text-body-secondary">Community</a></li>
        <li class="nav-item mb-2"><a href="https://youtu.be/6asXx6up7qQ" target="_blank" rel="noopener" class="nav-link p-0 text-body-secondary">Introduction Video</a></li>
      </ul>
    </div>

    <div class="col-12 col-sm-6 col-lg-5">
      <h4>Terms & Policies</h4>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a href="refund-policy" class="nav-link p-0 text-body-secondary">Refund Policy</a></li>
        <li class="nav-item mb-2"><a href="terms-conditions" class="nav-link p-0 text-body-secondary">Terms & Conditions</a></li>
        <li class="nav-item mb-2"><a href="security-privacy" class="nav-link p-0 text-body-secondary">Security & Privacy</a></li>
        <li class="nav-item mb-2"><a href="data-processing" class="nav-link p-0 text-body-secondary">Data Policy</a></li>
        <li class="nav-item mb-2"><a href="disclaimer" class="nav-link p-0 text-body-secondary">Disclaimer</a></li>
        <li class="nav-item mb-2"><a href="copyright" class="nav-link p-0 text-body-secondary">Copyright Notice</a></li>
      </ul>
    </div>
  </footer>
</div>

